import AuthProvider from "./AuthProvider"
import ConversationProvider from "./ConversationProvider"
import MessageProvider from "./MessageProvider"
import OrganisationProvider from "./OrganisationProvider"
import WorkspaceProvider from "./WorkspaceProvider"

export default {
  auth: AuthProvider,
  conversations: ConversationProvider,
  messages: MessageProvider,
  organisations: OrganisationProvider,
  workspaces: WorkspaceProvider,
}
